import React from 'react';
import PropTypes from 'prop-types';
import GraphicsList from './GraphicsList';

const GraphicsSectionMobile = ({ phoneBg, dir, title, items }) => {
  return (
    <section style={{ background: '#fff', padding: '48px 16px 40px' }} aria-label="graphics-mobile">
      <div style={{
        maxWidth: 440,
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: 24,
        direction: 'ltr'
      }}>
        <h2 style={{ margin: 0, fontSize: 24, fontWeight: 600, color: '#222', textAlign: dir === 'rtl' ? 'right' : 'left' }} dir={dir}>
          {title}
        </h2>

        <img src={phoneBg} alt="" aria-hidden="true" style={{ width: '100%', height: 'auto', display: 'block' }} />

        <GraphicsList items={items} dir={dir} />
      </div>
    </section>
  );
};

GraphicsSectionMobile.propTypes = {
  phoneBg: PropTypes.string.isRequired,
  dir: PropTypes.string,
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired
    })
  ).isRequired
};

export default GraphicsSectionMobile;
